// src/components/MessageCenter.js
import React, { useState, useEffect } from 'react';
import { collection, query, orderBy, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  Box,
  Typography,
} from '@mui/material';

const MessageCenter = ({ open, onClose }) => {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!open) return; // Inizia a leggere solo se la modale è aperta
    const messagesQuery = query(
      collection(db, 'messages'),
      orderBy('createdAt', 'desc')
    );
    const unsubscribe = onSnapshot(
      messagesQuery,
      (snapshot) => {
        const msgs = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
        }));
        setMessages(msgs);
        setLoading(false);
      },
      (err) => {
        console.error('Errore nel recupero dei messaggi:', err);
        setError('Errore nel caricamento dei messaggi.');
        setLoading(false);
      }
    );
    return () => unsubscribe();
  }, [open]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Messaggi</DialogTitle>
      <DialogContent dividers>
        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
            <CircularProgress />
          </Box>
        )}
        {error && (
          <Typography color="error">{error}</Typography>
        )}
        {!loading && !error && messages.length === 0 && (
          <Typography>Nessun messaggio disponibile.</Typography>
        )}
        {!loading && !error && (
          <List>
            {messages.map((msg) => (
              <ListItem key={msg.id} divider>
                <ListItemText
                  primary={msg.title}
                  secondary={
                    <>
                      <Typography variant="body2">{msg.body}</Typography>
                      <Typography variant="caption" color="text.secondary">
                        {msg.createdAt?.toDate 
                          ? msg.createdAt.toDate().toLocaleString() 
                          : new Date(msg.createdAt.seconds * 1000).toLocaleString()}
                      </Typography>
                    </>
                  }
                />
              </ListItem>
            ))}
          </List>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">Chiudi</Button>
      </DialogActions>
    </Dialog>
  );
};

export default MessageCenter;
